import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-p-disclosure-and-auth',
    templateUrl: './p-disclosure-and-auth.component.html',
    styleUrls: ['./p-disclosure-and-auth.component.scss'],
    standalone: false
})
export class PDisclosureAndAuthComponent {
     isSubmitted:boolean = false;

     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService,
          private modalService: NgbModal, private _router: Router) {
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit(): void {
          if(this.enrollmentService.inProcess === true){
               this.generalService.pageLogging("disclosure", null, "", "Tried back button after enroll:" + this.enrollmentService.newCustomer?.name,"").subscribe((v: any) => { });
                    this._router.navigateByUrl('/signup/23')
          }
          setTimeout(() => this.scrollToTop(), 500);
     }

     ngAfterViewInit() {
          
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     get pageValid() {
          return this.enrollmentService.newCustomer!.eulaAgreement?.readDisclosure!.toString() === 'agree';
     }

     localTranslation(translatedText:string){
          translatedText = translatedText.replace(`##docBaseUrl##`, environment.APP_PSP_DOC_BASE_URL);
          return translatedText;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {
          this.enrollmentService.saveToLocal();
     }
}
